<template>
  <div>
    <section class="container platform faq-container">
      <div class="row">
        <div class="col faq-title">
          <h3>Frequently asked questions</h3>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <v-tabs fixed-tabs color="#fafafa" v-model="tab" height="75px">
            <v-tabs-slider style="opacity: 0.0"></v-tabs-slider>
            <v-tab class="faqTab first" active-class="faqTab-active" :key="1">Company</v-tab>
            <v-tab class="faqTab" active-class="faqTab-active" :key="2">Services</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <!-- Corporate FAQ -->
            <v-tab-item :key="1">
              <v-card flat>
                <v-card-text class="tab-content" id="faqTabContent">
                  <div
                    class="tab-pane fade show active"
                    id="home"
                    role="tabpanel"
                    aria-labelledby="home-tab"
                  >
                    <div class="faq-pane">
                      <p class="faq-btn">1) What type of company is AcceleFreight?</p>
                      <div class id="faq-corporate-1">
                        <v-card flat color="#fafafa">
                          <v-card-text>
                            We are generally identified as a Multimodel-Transport-Operator (MTO).
                            An MTO is an entity who manages the movement of goods across different modes of transport, processes and stake holders.
                            <br />At AcceleFreight, we are currently focused on providing our customers with freight forwarding and warehousing services in addition to the supporting services such as ground transportation and customs clearance.
                          </v-card-text>
                        </v-card>
                      </div>
                    </div>
                    <div class="faq-pane">
                      <p class="faq-btn">2) What makes AcceleFreight different?</p>
                      <div class id="faq-corporate-2">
                        <v-card flat color="#fafafa">
                          <v-card-text>
                            AcceleFreight is taking a different approach to deliver its services to customers and managing its internal operations.
                            We use a digital centralized platform that will manage all the customers' logistical requirements.
                            <br />The platform will allow our customers to get an instant shipment quote, evaluate the price of the shipment and what they are paying for, manage their bookings, and track the progress of their shipments.
                            This will streamline the entire process with the goal of providing competitive pricing, reducing lead times, and increasing efficiency in day to day operations.
                          </v-card-text>
                        </v-card>
                      </div>
                    </div>
                    <div class="faq-pane">
                      <p class="faq-btn">3) When can we sign up?</p>
                      <div class id="faq-corporate-3">
                        <v-card flat color="#fafafa">
                          <v-card-text>
                            The platform is open for sign up. Go
                            <a
                              href="https://alfred.accelefreight.com/register"
                            >here</a> to sign up.
                          </v-card-text>
                        </v-card>
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Services FAQ -->
            <v-tab-item :key="2">
              <v-card-text class="tab-content" id="faqTabContent">
                <div
                  class="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div class="faq-pane">
                    <p class="faq-btn">1) How do we appoint you as our freight forwader?</p>
                    <div class id="faq-corporate-1">
                      <v-card flat color="#fafafa">
                        <v-card-text>
                          <p>Generally, an appointment letter and supporting documents are required to appoint a freight forwarder. Requirements differ across different countries, and the general requirement in Malaysia are as follows:</p>
                          <ul>
                            <li class="py-1">
                              An appointment letter printed on company letter head, signed by a company director along with the company stamp.
                              <br />We are more than happy to assist you on this process. You will need to provide us a
                              <b>soft copy of your company letter head</b> and we will prepare the necessary documentation for sign-of and stamping.
                            </li>
                            <li
                              class="py-1"
                            >Company incorporation/registration document (Form 9, Form D)</li>
                            <li class="py-1">List of registered company directors (Form 49, Form A)</li>
                            <li
                              class="py-1"
                            >Proof of registered address (utility bill). Should your registered address under the company registrar differ from your current operating address (as shown by the utility bill), a photocopy of your tenancy agreement will be required.</li>
                            <li
                              class="py-1"
                            >Colored photocopy of signed director's identification card</li>
                          </ul>
                          <p>Some requirements may differ depending on your company's operations and registration details. Do reach out to us to get more information, we are more than happy to help.</p>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                  <div class="faq-pane">
                    <p class="faq-btn">2) Do you handle shipment of personal items?</p>
                    <div class id="faq-corporate-1">
                      <v-card flat color="#fafafa">
                        <v-card-text>
                          <p>Unfortunately, we do not handle shipment of personal items. Our services are only available for legally registered corporate/business entities.</p>
                        </v-card-text>
                      </v-card>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: null
    };
  }
};
</script>

<style>
.faq-container .faqTab {
  border-bottom: 0px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-bottom: 30px;

  border-radius: 0px;
  border-top: 1px solid #e1e1e1;
  border-bottom: 1px solid #e1e1e1;
  border-right: 1px solid #e1e1e1;
  color: #212121 !important;
  opacity: 1 !important;
  width: 450px;

  text-transform: capitalize;
}

.faq-container .faqTab-active {
  color: #007bff !important;
  background-color: #fff !important;
  opacity: 1 !important;
}

.faqTab.first {
  border-left: 1px solid #e1e1e1;
}

.tab-content {
  background-color: #fafafa;
}
</style>
